import { ReceiptLookupService } from './model/squareup/buyerportal/receiptlookup/service';
import rpc from './rpc';

const receiptLookupClient = ReceiptLookupService.create(rpc());

export default receiptLookupClient;
